import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import styles from "./orders.module.css";
import { useDispatch, useSelector } from "react-redux";
import { getOrdersThunk } from "../../services/actions/orders_actions";
import { getDataFromRoutes, setMetaTags } from "../../utils/util_functions";
import { getCookie } from "../../utils/cookie";
import { getMyOrders, getLoading, getUser, getCustomer, getMyFirms, getRoutes } from "../../services/selectors";
import Loader from "../../components/loader/loader";
import Paginator from "../../components/paginator/paginator";
import OrdersItem from "../../components/orders/orders_item";
import FindUser from "../../components/find_user_or_firm/find_user";
import FindFirm from "../../components/find_user_or_firm/find_firm";
import { ORDER_STATUSES, USER_ROLES, PAYMENT_STATUSES } from "../../utils/constants";
import ButtonPlusMinus from "../../components/button_plus_minus/button_plus_minus";
import { SET_CUSTOMER } from "../../services/actions/customer_actions";
import DropDownList from "../../components/drop_down_list/drop_down_list";
import { getFirmsThunk } from "../../services/actions/firms_actions";


const Orders = () => {

  const [page, setPage] = useState(1);
  const [showFilters, setShowFilters] = useState(false);
  const [showUsersList, setShowUsersList] = useState(false);
  const [showStatusList, setShowStatusList] = useState(false);
  const [showYearsList, setShowYearsList] = useState(false);
  const [showPayStatusList, setShowPayStatusList] = useState(false);
  const [showFirmsList, setShowFirmsList] = useState(false);
  const [statusParameter, setStatusParameter] = useState(null);
  const [yearParameter, setYearParameter] = useState(null);
  const [firmParameter, setFirmParameter] = useState(null);
  const [payParameter, setPayParameter] = useState(null);
  const [filterOn, setFilterOn] = useState(false);

  const [yearsList, setYearsList] = useState([]);

  const dispatch = useDispatch();
  const { count, pages, orders } = useSelector(getMyOrders);
  const isLoading = useSelector(getLoading);
  const user = useSelector(getUser);
  const customer = useSelector(getCustomer);
  const firms = useSelector(getMyFirms);

  const accessToken = getCookie('accessToken') || '';
  const refreshToken = getCookie('refreshToken') || '';

  const routes = useSelector(getRoutes);
  const location = useLocation();

  useEffect(() => {
    const {
      metaTitle, metaDescription, metaKeywords, metaRobots
    } = getDataFromRoutes(location.pathname, routes);
    setMetaTags(
      metaTitle, metaDescription,
      metaKeywords, metaRobots
    )
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if ((user.role !== USER_ROLES.customer && user.id !== customer.id) ||
      (statusParameter !== null && statusParameter !== 'любой статус') ||
      (yearParameter !== null && yearParameter !== 'любой год') ||
      (firmParameter !== null && firmParameter !== 'любой плательщик' && firmParameter !== 'частное лицо') ||
      (payParameter !== null && payParameter !== 'любой статус')
    ) {
      setFilterOn(true);
      setShowFilters(true);
    } else {
      setFilterOn(false);
    }
  }, [customer, statusParameter, yearParameter, firmParameter, payParameter]);

  const getFirmId = (name=null, list) => {
    if (!name || name === 'любой плательщик') {
      return null;
    }
    if (name === 'частное лицо') {
      return -1;
    } else {
      return list.find(firm => firm.name === name)?.id
    }
  }

  useEffect(() => { window.scrollTo({ top: 0, left: 0 }) }, []);

  useEffect(() => {
    let list = ['любой год'];
    for (let year = new Date().getFullYear(); year >= 2024; year--) {
      list.push(year);
    }
    setYearsList(list);
  }, []);

  const handleSearch = () => {
    // тут добавить фильтр по оплате
    setPage(1);
    if (accessToken && refreshToken) {
      dispatch(
        getOrdersThunk(
          accessToken,
          refreshToken,
          1,
          customer.id,
          ORDER_STATUSES.find(item => item.name === statusParameter)?.value,
          yearParameter,
          getFirmId(firmParameter, firms),
          PAYMENT_STATUSES.find(item => item.name === payParameter)?.value
        ));
    }
  }

  function closeByEsc(e) {
    if (e.key === "Escape") {
      setShowUsersList(false);
      setShowStatusList(false);
      setShowYearsList(false);
      setShowFirmsList(false);
      setShowPayStatusList(false);
    }
  }

  useEffect(() => {
    document.addEventListener('keydown', closeByEsc);
    return (() => document.removeEventListener('keydown', closeByEsc));
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (accessToken && refreshToken) {
      dispatch(
        getOrdersThunk(
          accessToken,
          refreshToken,
          page,
          customer.id,
          ORDER_STATUSES.find(item => item.name === statusParameter)?.value,
          yearParameter,
          getFirmId(firmParameter, firms)
        ));
    }
    // eslint-disable-next-line
  }, [dispatch, page]);

  const handleClickContainer = (e) => {
    // закрываем ненужные списки
    if (
      e.target.name !== 'last_name' && e.target.name !== 'status' &&
      e.target.name !== 'year' && e.target.name !== 'firm' &&
      e.target.name !== 'payment_status'
    ) {
      setShowUsersList(false);
      setShowStatusList(false);
      setShowYearsList(false);
      setShowFirmsList(false);
      setShowPayStatusList(false);
      return null;
    }
    if (e.target.name === 'last_name') {
      setShowStatusList(false);
      setShowYearsList(false);
      setShowFirmsList(false);
      setShowPayStatusList(false);
      return null;
    }
    if (e.target.name === 'status') {
      setShowUsersList(false);
      setShowYearsList(false);
      setShowFirmsList(false);
      setShowPayStatusList(false);
      return null;
    }
    if (e.target.name === 'year') {
      setShowUsersList(false);
      setShowStatusList(false);
      setShowFirmsList(false);
      setShowPayStatusList(false);
      return null;
    }
    if (e.target.name === 'firm') {
      setShowUsersList(false);
      setShowStatusList(false);
      setShowYearsList(false);
      setShowPayStatusList(false);
      return null;
    }
    if (e.target.name === 'payment_status') {
      setShowUsersList(false);
      setShowStatusList(false);
      setShowYearsList(false);
      setShowFirmsList(false);
      return null;
    }
  }


  const handleClearFilter = () => {
    setPage(1);
    setStatusParameter(null);
    setYearParameter(null);
    setFirmParameter(null);
    setPayParameter(null);
    dispatch({ type: SET_CUSTOMER, customer: user });
    if (accessToken && refreshToken) {
      dispatch(
        getOrdersThunk(accessToken, refreshToken, page, user.id)
      );
      dispatch(
        getFirmsThunk(accessToken, refreshToken, user.id)
      );
    }
  }

  return (
    <main className="main">
      <div className={styles.container} onClick={handleClickContainer}>
        {isLoading ? <Loader /> : null}
        <div className={`${styles.filter_container} ${!showFilters && styles.filter_container__collapsed}`}>
          <div className={styles.subtitle_button_container}>
            <p className={`subtitle subtitle__left ${styles.subtitle}`} onClick={() => setShowFilters(!showFilters)}>
              Фильтрация заказов{filterOn && <span className="black"> включена</span>}
            </p>
            <ButtonPlusMinus state={showFilters} setState={setShowFilters} />
          </div>
          <div className={styles.ddl_container}>
            {(user.role === USER_ROLES.manager || user.role === USER_ROLES.superuser) &&
              <FindUser
                showUsersList={showUsersList}
                setShowUsersList={setShowUsersList}
                labelText="по пользователю"
              />
            }
            <FindFirm
              showFirmsList={showFirmsList}
              setShowFirmsList={setShowFirmsList}
              labelText="по плательщику"
              firmParameter={firmParameter}
              setFirmParameter={setFirmParameter}
              firms={firms}
              customer={customer}
            />
            <DropDownList
              label="по текущему статусу"
              showList={showStatusList}
              setShowList={setShowStatusList}
              list={ORDER_STATUSES}
              itemName="status"
              value={statusParameter}
              setValue={setStatusParameter}
            />
            <DropDownList
              label="по оплате"
              showList={showPayStatusList}
              setShowList={setShowPayStatusList}
              list={PAYMENT_STATUSES}
              itemName="payment_status"
              value={payParameter}
              setValue={setPayParameter}
            />
            <DropDownList
              label="по году создания"
              showList={showYearsList}
              setShowList={setShowYearsList}
              list={yearsList}
              itemName="year"
              value={yearParameter}
              setValue={setYearParameter}
            />
          </div>
          <div className={styles.button_container}>
            <button className="button" onClick={handleSearch}>
              Применить
            </button>
            <button className="button" onClick={handleClearFilter}>
              Сбросить
            </button>
          </div>
        </div>
        {count > 0 ?
          <>
            <table className={styles.table}>
              <thead className={styles.thead}>
                <tr className={styles.tr_head}>
                  <th className={styles.th}>Номер / <br /> дата заказа</th>
                  <th className={styles.th}>Статус</th>
                  <th className={styles.th}>Сумма / <br /> состав заказа</th>
                  <th className={styles.th}>Оплата</th>
                  <th className={styles.th}>Плательщик</th>
                </tr>
              </thead>
              <tbody className={styles.body}>
                {orders.map((order, index) =>
                  <React.Fragment key={order.id}>
                    <OrdersItem order={order} index={index} ordersLength={orders.length} />
                  </React.Fragment>
                )}
              </tbody>
            </table>
            {
              (pages > 1) &&
              <div className={styles.paginatorWrapper}>
                <Paginator
                  page={page}
                  setPage={setPage}
                  pages={pages}
                />
              </div>
            }
          </> :
          <p className={styles.text}>Заказы не найдены.</p>
        }
      </div>
    </main>
  );
};

export default Orders;
